/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Chip_VisibilityInputs */

const tr_landing_community_chip_visibility = /** @type {(inputs: Landing_Community_Chip_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görünürlük kontrolü`)
};

const en_landing_community_chip_visibility = /** @type {(inputs: Landing_Community_Chip_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibility control`)
};

const de_landing_community_chip_visibility = /** @type {(inputs: Landing_Community_Chip_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sichtbarkeitskontrolle`)
};

const ru_landing_community_chip_visibility = /** @type {(inputs: Landing_Community_Chip_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контроль видимости`)
};

/**
* | output |
* | --- |
* | "Visibility control" |
*
* @param {Landing_Community_Chip_VisibilityInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_chip_visibility = /** @type {((inputs?: Landing_Community_Chip_VisibilityInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Chip_VisibilityInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_chip_visibility(inputs)
	if (locale === "de") return de_landing_community_chip_visibility(inputs)
	if (locale === "ru") return ru_landing_community_chip_visibility(inputs)
	return tr_landing_community_chip_visibility(inputs)
});